import {
    dmarcPolicyFilterParams,
    dmarcSubdomainPolicyFilterParams,
    domainTypeFilterParams,
} from '../../table/constants/filter-types';
import { translateStringRenderer } from '../../table/table-utils';

/* Table columns are determined by `field`, but we specify `colId` to use as the order_by query param on sort or filter */

/* Shared */
export const domainNameColumn = {
    colId: 'domain',
    field: 'domainName',
    headerName: 'Domain',
    suppressMenu: true,
    type: ['checkboxColumn', 'stringColumn'],
};

export const dmarcStatusPolicyColumn = {
    colId: 'dmarc_status_policy',
    field: 'dmarcPolicy',
    filterParams: dmarcPolicyFilterParams,
    headerName: 'DMARC Policy (p=)',
    type: ['policyIconColumn']
};

export const totalVolumeColumn = {
    colId: 'total_mail_count',
    field: 'totalVolume',
    filter: 'greaterOrLessThanFilter',
    headerName: 'Total Volume',
    type: ['numberColumn', 'rightAlignColumn']
};


/* Claimed Domains Tables */
export const dateApprovedColumn = {
    colId: 'date_approved',
    field: 'claimedDate',
    filter: 'singleDatePickerFilter',
    headerName: 'Claimed Date',
    type: ['dateColumn'],
};

export const dmarcSubdomainPolicyColumn = {
    colId: 'dmarc_subdomain_policy',
    field: 'subdomainPolicy',
    filterParams: dmarcSubdomainPolicyFilterParams,
    headerName: 'DMARC Policy (sp=)',
    type: ['policyIconColumn'],
};

export const domainGroupsColumn = {
    colId: 'domain_group_id',
    field: 'domainGroups',
    filter: 'basicMultiSelectFilter',
    headerName: 'Domain Group',
    sortable: false,
    type: ['commaSeparatedListColumn'],
};

export const domainTypeColumn = {
    cellRendererFramework: translateStringRenderer,
    colId: 'domain_type',
    field: 'domainType',
    filterParams: domainTypeFilterParams,
    headerName: 'Domain Type',
    type: ['stringColumn']
};

export const lastPolicyChangeDateColumn = {
    colId: 'last_dmarc_policy_change_date',
    field: 'lastPolicyChange',
    filter: 'singleDatePickerFilter',
    headerName: 'Last Policy Change',
    type: ['dateColumn'],
};


/* Discovered */
export const registrantColumn = {
    colId: 'registrant',
    field: 'registrant',
    headerName: 'Registrant',
    suppressMenu: true,
    type: ['stringColumn'],
};

export const registrantEmailColumn = {
    colId: 'registrant_email',
    field: 'registrantEmail',
    headerName: 'Registrant Email',
    suppressMenu: true,
    type: ['stringColumn'],
};

export const mxExistsColumn = {
    colId: 'mx_exists',
    field: 'mxExists',
    headerName: 'MX Record',
    suppressMenu: true,
    type: ['boolColumn'],
};

export const dateDiscoveredColumn = {
    colId: 'date_discovered',
    field: 'dateDiscovered',
    filter: 'singleDatePickerFilter',
    headerName: 'Discovered Date',
    type: ['dateColumn'],
};

export const whoIsColumn = {
    headerClass: 'disable-hover',
    headerName: 'WhoIs',
    sortable: false,
    suppressMenu: true,
    type: ['viewButtonColumn'],
};

